import type { Course } from '@/types/course'
import { coursesApi } from '../coursesApi'

interface Lifecycle {
  dispatch: (action: never) => unknown
  queryFulfilled: Promise<unknown>
}

/**
 * Убирает удаляемый курс из обоих списков «Мои курсы» сразу, не дожидаясь ответа
 * DELETE и перечитывания списков. Упал запрос — возвращает курс на место.
 */
export const dropCourseOptimistically = async (
  id: number,
  { dispatch, queryFulfilled }: Lifecycle,
) => {
  const drop = (draft: Course[]) => {
    const i = draft.findIndex((c) => c.id === id)
    if (i !== -1) draft.splice(i, 1)
  }
  const send = dispatch as (a: unknown) => { undo: () => void }
  const patches = [
    send(coursesApi.util.updateQueryData('getMyUnpublishedCourses', undefined, drop)),
    send(coursesApi.util.updateQueryData('getMyPublishedCourses', undefined, drop)),
  ]
  try {
    await queryFulfilled
  } catch {
    patches.forEach((p) => p.undo())
  }
}
